<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content cus-content">
        <businessNav
            :nav-data="navData"
            @navClick="navClick"
        ></businessNav>
        <pageTool></pageTool>
        <div class="page-block" v-if="rtData.index == 0">
            <a-collapse v-model:activeKey="activeKey" accordion style="margin-top: 20px">
                <a-collapse-panel v-for="item in rtData.list0" :key="item.secondCategoryId+'&'+item.id" :header="item.title">
                    <p v-html="rtData.text"></p>
                </a-collapse-panel>
            </a-collapse>
<!--            <div class="li-header">担保政策 <span>更多<DoubleRightOutlined /></span></div>-->
<!--            <div class="li-list" v-if="rtData.list0.length > 0">-->
<!--                <div class="li-list-row" v-for="(item, i) in rtData.list0" :key="i">-->
<!--                    <div class="li-list-row-dodd"></div>-->
<!--                    <div class="li-list-row-content" @click="handleClick('300111&'+item.id)">-->
<!--                        <div>{{ item.title }}</div>-->
<!--                        <div>{{ item.createTime.split(' ')[0] }}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="li-header">担保产品 <span>更多<DoubleRightOutlined /></span></div>-->
<!--            <div class="li-list" v-if="rtData.list1.length > 0">-->
<!--                <div class="li-list-row" v-for="(item, i) in rtData.list1" :key="i">-->
<!--                    <div class="li-list-row-dodd"></div>-->
<!--                    <div class="li-list-row-content" @click="handleClick('300112&'+item.id)">-->
<!--                        <div>{{ item.title }}</div>-->
<!--                        <div>{{ item.createTime.split(' ')[0] }}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div v-else-if="rtData.index == 1" class="page-img">
            <img :src="rtData.internalInstance.appContext.config.globalProperties.$imgUrl + rtData.imgUrl">
        </div>
        <div v-else-if="rtData.index == 2">
            <div class="page-content-html">
                <div v-html="rtData.domData"></div>
                <div v-if="rtData.resources.length > 0">
                    <div class="file-download" v-for="(item, i) in rtData.resources" :key="i">
                        <div>附件{{ i+1 }}：{{ item.title }}</div>
                        <a :href="rtData.internalInstance.appContext.config.globalProperties.$imgUrl + item.url">下载文件</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import DoubleRightOutlined from '@ant-design/icons-vue/lib/icons/DoubleRightOutlined'
import Header from "@/components/SNInfo/Header"
import businessNav from "@/components/nav/businessNav"
import pageTool from "@/components/nav/pageTool"
import { onMounted, reactive } from 'vue'
const banner = require('@/assets/img/page_banner_1.png')
const businessIcon0 = require('@/assets/img/business_1.png')
const businessIcon1 = require('@/assets/img/business_2.png')
const businessIcon2 = require('@/assets/img/business_0.png')
import {getProcessList, getProcessDetail} from '@/api/policy'
import {getCurrentInstance, ref, watch} from "@vue/runtime-dom";
import {notification} from "ant-design-vue";
export default {
    name: "Home",
    setup() {
        const title = {
            cn: '信贷服务',
            en: 'CREDIT SERVICE',
            hasSearch: true,
            titleStyle: false,
            banner
        }
        const rtData = reactive({
            list0: [],
            list1: [],
            index: 0,
            domTitle: '',
            text: '',
            domData: '',
            resources: [],
            imgUrl: '',
            internalInstance: getCurrentInstance(),
            show: false
        })
        const navData = reactive({
            menuNames: [{name: '业务介绍', icon: businessIcon0}, {name: '业务流程', icon: businessIcon1}, {name: '业务办理', icon: businessIcon2}],
            activeName: '业务介绍'
        })
        const nameIndex = {'业务介绍': 0,'业务流程': 1,'业务办理': 2}
        const initList = async () => {
            const params0 = {"current": 1,"model": {"secondCategoryId": 300111}, "size": 3}
            const params1 = {"current": 1,"model": {"secondCategoryId": 300112}, "size": 3}
            const data0 = await getProcessList(params0)
            const data1 = await getProcessList(params1)
            for (const i in data0.records) {
                data0.records[i].secondCategoryId = 300111
            }
            for (const i in data1.records) {
                data1.records[i].secondCategoryId = 300112
            }
            rtData.list0 = [...data0.records,...data1.records]
        }
        const navClick = (name) => {
            if (name != '业务介绍') {
                if (!rtData.show) {
                    notification.warning({ message: '点击一个内容!', description: '', duration: 5 })
                    return
                }
            }
            navData.activeName = name
            rtData.index = nameIndex[name]
        }
        const activeKey = ref(['1'])
        const getText = async (id) => {
            const data = await getProcessDetail(id)
            rtData.text = data.text
            rtData.show = true
            rtData.imgUrl = data.imgs
            rtData.domData = data.process
            rtData.resources = data.resources
            // navClick('业务流程')
        }
        watch(activeKey, val => {
            if (val) {
                getText(val)
            }
        })
        // const handleClick = async (id) => {
        //     const data = await getProcessDetail(id)
        //     rtData.show = true
        //     rtData.imgUrl = data.imgs
        //     rtData.domData = data.process
        //     rtData.resources = data.resources
        //     navClick('业务流程')
        // }
        onMounted(() => {
            initList()
        })
        return {
            title,
            rtData,
            navData,
            activeKey,
            navClick,
            // handleClick,
            getText
        }
    },
    components: {
        Header,
        businessNav,
        // DoubleRightOutlined,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
.page-content {
    padding 20px 30px
    .page-block {
        .li-header {
            margin-top 20px
        }
    }
    .page-block >>> .ant-collapse > .ant-collapse-item > .ant-collapse-header {
        color #44A73D
        font-size 14px
        font-weight bolder
    }
}
.page-img {
    width 100%
    padding 20px
}
.page-img img {
    width 100%
}
</style>